import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withKeys as _withKeys, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5763688"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field inline-block" }
const _hoisted_2 = { class: "lbl-calendar font-normal text-xl flex" }
const _hoisted_3 = { class: "field inline-block ml-2" }
const _hoisted_4 = { class: "field inline-block ml-2" }
const _hoisted_5 = {
  class: "field inline-block ml-2",
  style: {"min-width":"250px"}
}
const _hoisted_6 = { class: "p-input-icon-left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_8 = { class: "field inline-block ml-3 mt-2" }
const _hoisted_9 = { class: "formgroup-inline" }
const _hoisted_10 = { class: "field-radiobutton md:mr-1" }
const _hoisted_11 = {
  for: "status_full",
  class: "ml-2"
}
const _hoisted_12 = { class: "field-radiobutton md:mr-1" }
const _hoisted_13 = {
  for: "status_will_come",
  class: "ml-2"
}
const _hoisted_14 = { class: "field-radiobutton md:mr-1" }
const _hoisted_15 = {
  for: "status_visited",
  class: "ml-2"
}
const _hoisted_16 = {
  key: 0,
  class: "field inline-block ml-auto mr-2"
}

import { reactive, computed, ref, onUpdated } from "vue";
import Dropdown, { DropdownChangeEvent } from "primevue/dropdown";
import Button from "primevue/button";
import RadioButton from "primevue/radiobutton";
import Calendar from "primevue/calendar";
import InputText from "primevue/inputtext";
import { get, useDateFormat, noop, set } from "@vueuse/core";
import { DATE_FORMAT, MILLISECONDS_IN_DAY } from "@/clinic/typings/constants/booking";
import { CUSTOMER_ID_NAME_NAME_KANA_PHONE_PLACEHOLDER_SELECT } from "@/clinic/typings/constants/clinic";
import {
  BookingViewEnum,
  BookingViewOptions,
  BookingStatusEnum,
  BookingStatusFull,
  BookingViewTypeEnum,
  BookingViewTypeDaysEnum,
  BookingStatusColorOptions,
  BookingSourceColorClasses,
} from "@/clinic/typings/enums/booking";
import { IBookingPickedTime } from "@/clinic/typings";
import TimeUtils from "@/clinic/utils/time-utils";
import moment from "moment";
import _ from "lodash";


export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  props: {
    pickedDate: null,
    viewType: null,
    switchView: { type: Boolean },
    showFreeSpace: { type: Boolean }
  },
  emits: ["filter", "prev", "next", "today", "changeViewType", "export", "dateSelect"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  pickedDate: IBookingPickedTime;
  viewType: BookingViewTypeEnum;
  switchView: boolean;
  showFreeSpace?: boolean;
};

const pickedStartTime = ref(new Date());




const viewTypeDays = computed(() => {
  return props.viewType == BookingViewTypeEnum.Week ? BookingViewTypeDaysEnum.week : BookingViewTypeDaysEnum.day;
});

const hasWeekViewType = computed((): boolean => props.viewType == BookingViewTypeEnum.Week);

const pickedTimeText = computed((): string => {
  const { start } = props.pickedDate;
  const end = get(hasWeekViewType)
    ? new Date(TimeUtils.toEndWeekDate(start).getTime() - MILLISECONDS_IN_DAY)
    : TimeUtils.toEndDateTime(TimeUtils.formatIsoDateYMD(start.toString()));
  return props.viewType == BookingViewTypeEnum.Day
    ? get(useDateFormat(start, DATE_FORMAT))
    : TimeUtils.formatRangeDateTime(start, end, false);
});

const onPrev = () => {
  const { start: startDate } = props.pickedDate;
  const start = new Date(startDate);
  start.setDate(start.getDate() - get(viewTypeDays));

  const end = new Date(start);
  end.setDate(end.getDate() + get(viewTypeDays));

  set(currentPickedDayView, start);
  emits("prev", { start, end });
};
const onNext = () => {
  const { start: startDate } = props.pickedDate;
  const start = new Date(startDate);
  start.setDate(start.getDate() + get(viewTypeDays));

  const end = new Date(start);
  end.setDate(end.getDate() + get(viewTypeDays));

  set(currentPickedDayView, start);
  emits("next", { start, end });
};
const onToday = () => {
  const start = moment().startOf("day").toDate();
  set(currentPickedDayView, start);
  emits("today", get(hasWeekViewType) ? TimeUtils.weekToday() : { start: start, end: moment().endOf("day").toDate() });
};

const currentPickedDayView = ref(props.pickedDate.start);

const onExport = (event: Event) => emits("export", event);
const onChangeViewType = ({ value: newViewType }: DropdownChangeEvent) => {
  let newPickedTime;

  if (newViewType == BookingViewTypeEnum.Week) {
    const baseDate = get(currentPickedDayView) || props.pickedDate.start;
    newPickedTime = TimeUtils.weekToday(baseDate);
  } else {
    const currentDate = get(currentPickedDayView) ? new Date(get(currentPickedDayView)) : new Date();

    const startOfDay = new Date(currentDate);
    startOfDay.setHours(0, 0, 0, 0);

    const endOfDay = new Date(currentDate);
    endOfDay.setHours(23, 59, 59, 999);

    newPickedTime = { start: startOfDay, end: endOfDay };
  }

  emits("changeViewType", newViewType, newPickedTime);
};

const formFilter = reactive({
  status: BookingStatusFull,
  view: props.viewType || BookingViewEnum.Day,
  term: "",
});

const formRef = ref<HTMLFormElement | null>(null);

const onFilter = (source: string, event: { target: HTMLInputElement }) => {
  let value = event.target.value;
  if (source == "status") {
    const element = event?.target?.parentElement?.firstChild?.firstChild as HTMLInputElement;
    value = element?.value || "";
  }
  emits("filter", { [source]: value }, get(formRef) as unknown as HTMLFormElement);
};

const onDateSelect = (date: Date) => {
  set(currentPickedDayView, date);
  emits("dateSelect", date);
};

onUpdated(() => {
  if (props.pickedDate?.start?.getTime() != get(pickedStartTime)?.getTime())
    set(pickedStartTime, props.pickedDate.start);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    ref_key: "formRef",
    ref: formRef,
    class: "form-booking-filter formgrid grid grid-nogutter",
    onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_unref(noop) && _unref(noop)(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, [
        _createTextVNode(_toDisplayString(_unref(pickedTimeText)) + " ", 1),
        (__props.viewType == _unref(BookingViewTypeEnum).Day)
          ? (_openBlock(), _createBlock(_unref(Calendar), {
              key: 0,
              modelValue: pickedStartTime.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pickedStartTime).value = $event)),
              icon: "icon-lms icon-lms_calendar icon-orange text-xl ml-2",
              showIcon: "",
              onDateSelect: onDateSelect
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(Button), {
        icon: "icon-lms icon-lms_left",
        class: "btn-white border-round-md border-noround-right",
        "aria-label": "Previous",
        onClick: onPrev
      }),
      _createVNode(_unref(Button), {
        icon: "icon-lms icon-lms_right",
        class: "btn-white border-round-md border-noround-left",
        "aria-label": "Next",
        onClick: onNext
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(Button), {
        label: "今日",
        class: "btn-white text-xs w-80",
        onClick: onToday
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, [
        _hoisted_7,
        _createVNode(_unref(InputText), {
          modelValue: formFilter.term,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFilter.term) = $event)),
          name: "term",
          placeholder: _unref(CUSTOMER_ID_NAME_NAME_KANA_PHONE_PLACEHOLDER_SELECT),
          onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (onFilter('term', $event)), ["enter"]))
        }, null, 8, ["modelValue", "placeholder"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_unref(RadioButton), {
            modelValue: formFilter.status,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formFilter.status) = $event)),
            inputId: "status_full",
            name: "status",
            value: _unref(BookingStatusFull),
            required: true,
            onChange: _cache[4] || (_cache[4] = ($event: any) => (onFilter('status', $event)))
          }, null, 8, ["modelValue", "value"]),
          _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(BookingStatusFull)), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_unref(RadioButton), {
            modelValue: formFilter.status,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formFilter.status) = $event)),
            inputId: "status_will_come",
            name: "status",
            value: _unref(BookingStatusEnum).will_come,
            required: true,
            onChange: _cache[6] || (_cache[6] = ($event: any) => (onFilter('status', $event)))
          }, null, 8, ["modelValue", "value"]),
          _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(BookingStatusEnum).will_come), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_unref(RadioButton), {
            modelValue: formFilter.status,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formFilter.status) = $event)),
            inputId: "status_visited",
            name: "status",
            value: _unref(BookingStatusEnum).visited,
            required: true,
            onChange: _cache[8] || (_cache[8] = ($event: any) => (onFilter('status', $event)))
          }, null, 8, ["modelValue", "value"]),
          _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(BookingStatusEnum).visited), 1)
        ])
      ])
    ]),
    (props.switchView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_unref(Dropdown), {
            id: "time-dropdown",
            modelValue: formFilter.view,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formFilter.view) = $event)),
            options: _unref(BookingViewOptions),
            optionValue: "value",
            optionLabel: "name",
            class: "time-dropdown",
            placeholder: _unref(BookingViewEnum).Day,
            onChange: onChangeViewType
          }, null, 8, ["modelValue", "options", "placeholder"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["field inline-block", { 'ml-auto': !props.switchView }])
    }, [
      _createVNode(_unref(Button), {
        label: "ダウンロード",
        icon: "icon-lms_download",
        class: "btn-download",
        onClick: _cache[10] || (_cache[10] = ($event: any) => (onExport($event)))
      })
    ], 2)
  ], 544))
}
}

})